import { Box } from '@mui/material';
import { useState, useContext, useEffect, useRef } from "react";
import React from "react";
import { GlobalStateContext } from '../../store/GlobalState';
import { useNavigate } from "react-router-dom";
import {
    GreenSmallContainer,
    OrangeSmallContainer,
    YellowSmallContainer,
    BlueSmallContainer,
    FourContainer,
    Heading,
    ToBeCompleteHeading,
    RemainingWorkHeading,
    ToDoNumber,
    HousingHeading,
    PrivateHeading,
    PinkSmallContainer,
    AllHeading,
    CEDDHeading,
    CEDDSmallContainer,
} from "../../assets/style"
import ReactLoading from "react-loading";
import { useLazyGetToDoListQuery } from "../../features/toDoList/toDoListApiSlice";
import CloseIcon from '@mui/icons-material/Close';
import CountdownContainer from "../CountdownTimer/CountdownContainer";

const ToDoListContainer = ({ date, refreshTodoListCounter }: { date: any, refreshTodoListCounter: any }) => {
    const [start, setStart] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [overview, setOverview] = React.useState<null | Overview>(null)
    const [getToDoListuery, result] = useLazyGetToDoListQuery();
    const [startCountdown, setStartCountdown] = useState(true);
    const [secondsLeftOfCountdown, setSecondsLeftOfCountdown] = useState(0);
    const navigate = useNavigate();
    const globalState = useContext(GlobalStateContext);
    type Overview = {
        "housingWorkCount": Number,
        "housingRemainingWorkCount": Number,
        "ceddWorkCount": Number,
        "ceddRemainingWorkCount": Number,
        "privateWorkCount": Number,
        "privateRemainingWorkCount": Number,
        "totalWorkCount": Number,
        "totalRemainingWorkCount": Number
        "privateWorkCount2": Number,
        "privateRemainingWorkCount2": Number,
    }

    useEffect(() => {
        // console.log("effect in to do data")
        if (globalState.token)
            handleData(date?.toISOString());
    }, [date?.toISOString(), refreshTodoListCounter])

    const handleData = async (date: any) => {
        // setOverview(null) // assign null value to activate bubble animation
        setIsLoading(true)
        try {
            // await getToDoListuery(date)
            getToDoListuery(date).then((data) => {
                if (data.error) {
                    navigate('/main')
                }
                setIsLoading(false); // Set isLoading to false when loading or updating is completed or when an error occurs
            });

        } catch (error) {
            // setIsLoading(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            localStorage.setItem('token', '');
            globalState.setToken('');
            navigate("/");
        } finally {
            setStartCountdown(false); // close the zero-second timer
            setStart(true);
        }
        // getToDoListuery(date);
    }

    useEffect(() => {
        // Shows timer 60 seconds before the re-rendering     
        // Input parameter:
        // console.log("effect in count down in todo")
        if (start) {
            const secondsOfCountdown = 60
            setSecondsLeftOfCountdown(secondsOfCountdown)
            setStartCountdown(true)
            // Process timer:
            const timeoutIds: any[] = []
            for (let i = 1; i <= 60; i++) {
                const timeoutID = setTimeout(() => {
                    setSecondsLeftOfCountdown(60 - i) // update seconds left
                }, 1000 * i)
                timeoutIds.push(timeoutID)
            }

            // output a callable object
            return () => {
                for (let i = 0; i < timeoutIds.length; i++) {
                    clearTimeout(timeoutIds[i])
                }
            };
        }
    }, [result.data, startCountdown, start])

    // fetch overview data from API endpoint 
    useEffect(() => {
        // console.log("effect in result in todo")
        if (result.isSuccess) {
            const responseData = result.data;
            setOverview(responseData as Overview);
        }
        // re-render the UI of the overview section for each interval
        const interval = setInterval(() => {
            handleData(date?.toISOString())
            // console.log(`Overview section is updated by interval handler whose ID = ${interval}`) // debug
        }, 1000 * 60);
        return () => clearInterval(interval);
    }, [result.data])

    return (
        <>
            <FourContainer flexGrow={1}>
                <Heading minHeight={'4%'}>To Do List 工作列表</Heading>
                <Box display="flex" minHeight={'23%'}>
                    <PinkSmallContainer flexGrow={1}>
                        <Box display="flex" alignItems={'center'}>
                            <AllHeading>All</AllHeading>
                            <GreenSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <ToBeCompleteHeading>
                                        To be Complete: <br />
                                        今日將要完成總數
                                    </ToBeCompleteHeading>
                                    <ToDoNumber flexGrow={1}>
                                        {/* {overview?.totalWorkCount?.toString() || <ReactLoading type={"bubbles"} color={'#000000'} />} */}
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.totalWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </GreenSmallContainer>
                            <OrangeSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <RemainingWorkHeading>
                                        Remaining Work Total: <br />
                                        剩餘工作總數
                                    </RemainingWorkHeading>
                                    <ToDoNumber>

                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.totalRemainingWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </OrangeSmallContainer>
                        </Box>
                    </PinkSmallContainer>
                </Box>
                <Box display="flex" minHeight={'23%'}>
                    <CEDDSmallContainer flexGrow={1}>
                        <Box display="flex" alignItems={'center'}>
                            <CEDDHeading>CEDD</CEDDHeading>
                            <GreenSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <ToBeCompleteHeading>
                                        To be Complete: <br />
                                        今日將要完成總數
                                    </ToBeCompleteHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.ceddWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </GreenSmallContainer>
                            <OrangeSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <RemainingWorkHeading>
                                        Remaining Work Total: <br />
                                        剩餘工作總數
                                    </RemainingWorkHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.ceddRemainingWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </OrangeSmallContainer>
                        </Box>
                    </CEDDSmallContainer>
                </Box>
                <Box display="flex" minHeight={'23%'}>
                    <YellowSmallContainer flexGrow={1}>
                        <Box display="flex" alignItems={'center'}>
                            <HousingHeading>Housing</HousingHeading>
                            <GreenSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <ToBeCompleteHeading>
                                        To be Complete: <br />
                                        今日將要完成總數
                                    </ToBeCompleteHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.housingWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </GreenSmallContainer>
                            <OrangeSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <RemainingWorkHeading>
                                        Remaining Work Total: <br />
                                        剩餘工作總數
                                    </RemainingWorkHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.housingRemainingWorkCount?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </OrangeSmallContainer>
                        </Box>
                    </YellowSmallContainer>
                </Box>
                <Box display="flex" minHeight={'23%'}>
                    <BlueSmallContainer flexGrow={1}>
                        <Box display="flex" alignItems={'center'}>
                            <PrivateHeading>Private</PrivateHeading>
                            <GreenSmallContainer flexGrow={1}>
                                <Box display="flex" alignItems={'center'}>
                                    <ToBeCompleteHeading>
                                        To be Complete: <br />
                                        今日將要完成總數
                                    </ToBeCompleteHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.privateWorkCount2?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </GreenSmallContainer>
                            <OrangeSmallContainer flexGrow={1}>
                                <Box display="flex">
                                    <RemainingWorkHeading>
                                        Remaining Work Total: <br />
                                        剩餘工作總數
                                    </RemainingWorkHeading>
                                    <ToDoNumber>
                                        {isLoading && (
                                            <ReactLoading type={"bubbles"} color={'#000000'} />
                                        )}
                                        {!isLoading && overview?.privateRemainingWorkCount2?.toString()}
                                    </ToDoNumber>
                                </Box>
                            </OrangeSmallContainer>
                        </Box>
                    </BlueSmallContainer>
                </Box>

                {/* Countdown */}
                <CountdownContainer
                    startCountdown={startCountdown}
                    secondsLeftOfCountdown={secondsLeftOfCountdown}
                />
            </FourContainer>
        </>
    )
};
export default ToDoListContainer;